import classes from "./Statuses.module.css";
export default function Statuses({ status, isLabel = true, className }) {
  const statusesColor = {
    active: {
      bgColor: "#EAFBF1",
      color: "#1F9560",
      label: "Active",
    },
    granted: {
      bgColor: "#EAFBF1",
      color: "#1F9560",
      label: "Granted",
    },
    approved: {
      bgColor: "#EAFBF1",
      color: "#1F9560",
      label: "Approved",
    },
    inactive: {
      bgColor: "#FFE3E3",
      color: "#F53649",
      label: "Inactive",
    },
    "system-deactivated": {
      bgColor: "#FFE3E3",
      color: "#F53649",
      label: "In-Active",
    },
    negotiating: {
      bgColor: "#FFF3E0",
      color: "#FF9500",
      label: "Negotiating",
    },
    expired: {
      bgColor: "#F2CCCC",
      color: "#BE0000",
      label: "Expired",
    },
    suspended: {
      bgColor: "#F2CCCC",
      color: "#BE0000",
      label: "Suspended",
    },
    completed: {
      bgColor: "#ECFDF3",
      color: "#109133",
      label: "Completed",
    },
    revision: {
      bgColor: "#DAEAFF",
      color: "#337DFE",
      label: "Revision",
    },
    resolved: {
      bgColor: "#ECFDF3",
      color: "#109133",
      label: "Resolved",
    },
    booked: {
      bgColor: "#ECFDF3",
      color: "#109133",
      label: "Booked",
    },
    paid: {
      bgColor: "rgba(0, 175, 38, 0.2)",
      color: "#00AF26",
      label: "Paid",
    },
    cancelled: {
      bgColor: "#FFE3E3",
      color: "#F53649",
      label: "Cancelled",
    },

    unverified: {
      bgColor: "#DAEAFF",
      color: "#337DFE",
      label: "Unverified",
    },
    pending: {
      bgColor: "#FAF2D9",
      color: "#CE9F00",
      label: "Pending",
    },
    requested: {
      bgColor: "#FAF2D9",
      color: "#CE9F00",
      label: "Requested",
    },
    proposed: {
      bgColor: "#FAF2D9",
      color: "#CE9F00",
      label: "Concluded",
    },
    concluded: {
      bgColor: "#F7EEFF",
      color: "#8C0AFF",
      label: "Concluded",
    },

    rejected: {
      bgColor: "#F2CCCC66",
      color: "#BE0000",
      label: "Rejected",
    },
    "not-granted": {
      bgColor: "#F2CCCC66",
      color: "#BE0000",
      label: "Not Granted",
    },

    funded: {
      bgColor: "#EAFBF1",
      color: "#1F9560",
      label: "Funded",
    },
    negotiating: {
      color: "#FF9500",
      bgColor: "#FFF3E0",
      label: "Negotiating",
    },
    revision: {
      color: "#337DFE",
      bgColor: "#DAEAFF",
      label: "Revision",
    },
  };
  return (
    <div
      className={`${classes.statusWrapper} ${
        !isLabel ? classes.withoutLabel : ""
      } ${className ? className : ""}`}
      style={{ backgroundColor: statusesColor[status]?.bgColor }}
    >
      {isLabel && (
        <p style={{ color: statusesColor[status]?.color }}>
          {statusesColor[status]?.label}
        </p>
      )}
    </div>
  );
}
